var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 49,
    viewBox: "0 0 153 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.684036C3.58172 0.684036 0 4.26576 0 8.68404V31.6928C0 34.8754 1.26428 37.9277 3.51472 40.1781L8.50592 45.1693C10.7564 47.4198 13.8086 48.684 16.9912 48.684H145C149.418 48.684 153 45.1023 153 40.684V8.68404C153 4.26576 149.418 0.684036 145 0.684036H8Z",
    fill: "#FDEE2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimButton);
export default __webpack_public_path__ + "static/media/sim-button.23d8d5311256fb87ac249e87c1d33282.svg";
export { ForwardRef as ReactComponent };